import { render } from "./PrivacyTermsComponent.vue?vue&type=template&id=73ebef03&scoped=true"
const script = {}

import "./PrivacyTermsComponent.vue?vue&type=style&index=0&id=73ebef03&lang=css"
import "./PrivacyTermsComponent.vue?vue&type=style&index=1&id=73ebef03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ebef03"]])

export default __exports__